interface Props {
  color: string | "#D0DEE6",
}
const ComplianceIcon = (props: Props) => {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="44" height="44" rx="3.5" fill="white"/>
      <path d="M26.4062 18.5938L20.9961 24.8438L18.5938 22.4902" stroke="#4F46E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M32.6123 15.4868C28.246 14.7036 26.4409 14.1235 22.5 12.3438C18.559 14.1235 16.7539 14.7036 12.3877 15.4868C11.5966 28.0239 21.747 32.353 22.5 32.6562C23.2529 32.353 33.4033 28.0239 32.6123 15.4868Z" stroke="#4F46E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="0.5" y="0.5" width="44" height="44" rx="3.5" stroke="#CCCCCC"/>
    </svg>
  )
}
export default ComplianceIcon;
